module.exports = __webpack_public_path__ + "media/images/banner/tjt/sp/travel03_1280_1280_zh-hant-f3d8f43c4759f7f790b95de3b3c6b90f.jpg";